export default __webpack_public_path__ + "static/media/user-card.6f409946.svg";